import { cn } from '@shadcn/lib/utils';
import { Card as ShadcnCard, CardContent } from '@shadcn/ui/card';
import React from 'react';

const customBackgroundClasses = {
  default: 'bg-white',
  muted: 'bg-secondary-200',
  transparent: 'bg-transparent',
};

export function Card({ background = 'default', ...props }: CardProps) {
  const customClasses = cn(customBackgroundClasses[background]);
  return (
    <ShadcnCard className={customClasses} {...props}>
      <CardContent>{props.children}</CardContent>
    </ShadcnCard>
  );
}

export type CardProps = React.ComponentProps<typeof ShadcnCard> & {
  readonly background?: 'default' | 'muted' | 'transparent';
};
